import { Box, ColorOptions, convertHexToRGBA, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useCallback, useEffect, useState } from 'react'
import { Animated, Easing, FlatList } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { tableItemStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { getString } from '../../util/languageStrings'
import { dateFormatter, DateFormatTypes, getHHMMSS } from '../../util/util'
import { DisplayDateFormat } from './DisplayDateFormat'
import { HOME, ReceivedTransactionStats } from './ReceivedTransactionStats'

export const RecentTransactions = () => {
  const { mid, getTrxn, fetchRecentTranasctions, selectedAppLanguage } = useStores((store) => ({
    mid: store.user.selectedMid,
    getTrxn: store.transactions.getTransactionsV3,
    fetchRecentTranasctions: store.transactions.fetchRecentTranasctionsForMobile,
    selectedAppLanguage: store.settings.config.selectedAppLanguage,
  }))

  //   const [fetchTxnColumns] = useLazyApiData(getTransactionsColumn)
  const [fetchTxn, { state: fetchTxnHandlerState }] = useLazyApiData(getTrxn)
  const [fetchTxnPolling, { state: fetchTxnPollingHandlerState }] = useLazyApiData(getTrxn)
  const [animateDropdown] = useState<any>(new Animated.Value(0))
  const [expandDropDown] = useState(true)
  const [receivedTxns, setReceivedTxns]: any = useState([])

  const expandOrCollapseDropdown = useCallback(() => {
    Animated.timing(animateDropdown, {
      toValue: expandDropDown ? 1 : 0,
      duration: 300,
      easing: Easing.linear,
      useNativeDriver: false,
    }).start()
  }, [animateDropdown, expandDropDown])

  useEffect(() => {
    // if (expandDropDown) {
    expandOrCollapseDropdown()
    // }
  }, [expandDropDown, expandOrCollapseDropdown])

  useEffect(() => {
    if (fetchTxnHandlerState === 'fulfilled' || fetchTxnPollingHandlerState === 'fulfilled') {
      const ListContent = fetchRecentTranasctions('received') ?? []
      let successTransaction = ListContent //Show all transactions //getSuccessTransaction(ListContent) // show only success transaction
      if (successTransaction?.length) {
        setReceivedTxns(successTransaction)
      }
    }
  }, [fetchRecentTranasctions, fetchTxnHandlerState, fetchTxnPollingHandlerState])

  const hitTnxApi = useCallback(() => {
    const today = new Date(Date.now())
    const currentDate = dateFormatter(today, DateFormatTypes.YYYYMMDD)
    fetchTxn(
      1,
      10,
      tableItemStrings.transactionDesc,
      `${currentDate}${tableItemStrings.startTime}`,
      `${currentDate}${getHHMMSS(today)}`,
      mid,
      'JSON',
      ...Array(8).fill(undefined),
      'Home',
      undefined,
      undefined,
      undefined,
      true,
    )
  }, [fetchTxn, mid])

  useEffect(() => {
    if (mid) {
      hitTnxApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mid])

  const renderCustomItem = (item: any, handleItemPress: any, bg = '#03753C' as ColorOptions, expanded = false) => {
    const txnStatus = item.transactionStatus
    return (
      <Box
        onPress={() => handleItemPress?.(item)}
        testID="recent-txn"
        underlayColor={'TRANSPARENT'}
        bg={bg}
        borderRadius={25}
        pr={expanded ? 10 : 4}
        pl={expanded ? 0 : 4}
        pv={expanded ? 0 : 2}
        pb={expanded ? 10 : 2}
        align={expanded ? 'flex-start' : 'center'}
        //flex={expanded ? 0.2 : undefined}
        //width={expanded ? 70 : undefined}
        justifyContent={expanded ? 'flex-start' : 'center'}>
        <Box flexDirection={'row'} align="center">
          <Text
            fontFamily={expanded ? 'JioType-Bold' : 'JioType-Medium'}
            letterSpacing={-0.06}
            fontSize={expanded ? 14 : 12}
            color="WHITE">
            {item.totalAmount}
          </Text>
          <ModBox
            show={txnStatus !== 'SUCCESS'}
            width={6}
            height={6}
            borderRadius={3}
            bg={
              txnStatus === 'FAILED' || txnStatus === 'ERROR'
                ? ('#FF7079' as ColorOptions)
                : ('#FFA319' as ColorOptions)
            }
            ml={5}
          />
        </Box>
        <ModBox show={expanded} opacity={0.5}>
          <DisplayDateFormat date={item?.date} />
        </ModBox>
      </Box>
    )
  }

  return (
    <Box>
      <Spacer size={30} direction="vertical" />
      <ReceivedTransactionStats
        fetchTxn={fetchTxnPolling}
        fetchTxnState={fetchTxnPollingHandlerState}
        screenName={HOME}
      />

      <ModBox show={receivedTxns?.length < 0}>
        <Spacer size={10} direction="vertical" />
        <Box flexDirection={'row'} alignItems="flex-start" justifyContent="space-between">
          <Box width={'50%'}>
            <Text
              numberOfLines={3}
              fontFamily={'JioType-Medium'}
              fontSize={12}
              letterSpacing={-0.06}
              color={convertHexToRGBA('#fff', 70) as ColorOptions}>
              {getString(selectedAppLanguage, 'selectedAppLanguage')}
            </Text>
          </Box>
          <SvgImage imageName="RupeeIconRepeated" />
        </Box>
      </ModBox>

      <ModBox show={receivedTxns?.length > 0}>
        <Spacer size={10} direction="vertical" />
        <Box
          borderWidth={0.8}
          borderStyle="dashed"
          borderColor={convertHexToRGBA('#fff', 20) as ColorOptions}
          borderLeftWidth={0}
          borderRightWidth={0}>
          <Box
            //onPress={() => receivedTxns?.length > 0 && setExpandDropDown(!expandDropDown)}
            underlayColor={'TRANSPARENT'}
            pv={10}
            flexDirection={'row'}
            align="center"
            justify="space-between">
            <Text fontFamily={'JioType-Medium'} letterSpacing={-0.07} fontSize={14} color="WHITE">
              {getString(selectedAppLanguage, 'rencentTransactions')}
            </Text>
            {/* <Box flexDirection="row" overflowX={'visible'} flex={1} pl={5} pr={24} justify={'flex-end'}>
              <Animated.View style={{ opacity: animateOpacity }}>
                <FlatList
                  data={receivedTxns?.slice(0, 3)}
                  renderItem={({ item }: any) =>
                    renderCustomItem(item, null, convertHexToRGBA('#fff', 16) as ColorOptions, false)
                  }
                  extraData={receivedTxns}
                  horizontal={true}
                  scrollEnabled={true}
                  showsHorizontalScrollIndicator={false}
                  ItemSeparatorComponent={() => <Spacer size={5} direction={'horizontal'} />}
                />
              </Animated.View>
            </Box>
            <Animated.View style={{ transform: [{ rotateZ: rotateIcon }], position: 'absolute', right: 0 }}>
              <Icon id="ARROW_DOWN" color={'WHITE'} size={22} />
            </Animated.View> */}
          </Box>
          {/* <Animated.View
            style={{
              //   transform: [{ scaleY: expand }],
              overflow: 'hidden',
              height: expand,
            }}> */}
          <Box mb={3} justifyContent="space-between" flexDirection="row">
            <FlatList
              contentContainerStyle={{ alignItems: 'stretch', justifyContent: 'space-between' }}
              scrollEnabled={true}
              horizontal
              style={{ width: '100%' }}
              data={receivedTxns?.slice(0, 10)}
              renderItem={({ item }: any) =>
                renderCustomItem(item, () => console.log('Do not collapse'), 'TRANSPARENT' as ColorOptions, true)
              }
              extraData={receivedTxns}
              ItemSeparatorComponent={() => <Spacer size={5} direction={'horizontal'} />}
            />
            {/* <Box>
                <Icon id="ARROW_RIGHT" color={'WHITE'} size={22} />
              </Box> */}
          </Box>
          {/* </Animated.View> */}
        </Box>
      </ModBox>
    </Box>
  )
}
